import * as v2 from './v2/';
import * as v3 from './v3/';
import * as prebid from './prebid/';
import metricsFacade, * as metricsModule from './metrics/';
export { loadPrebid, matchesOutstreamBidGeo } from './clients/prebid';
export { getGeo } from './core/geo';
export { getConfig, setAditudeParams, trackAditudeImpression } from './v2/index';
export { VideoType } from './types/config';
export { buildSupplyChain, } from './core/supply-chain';
export { shouldDeferAdRequest } from './core/ad-request-policy';
export { fetchVideoBids, fetchVideoBidsWithResult, init as initAmazonPublisherServices, } from './amazon/index';
export { DEFAULT_OUTSTREAM_SIZE, OutstreamDemandProvider, } from './types/outstream';
// Keep the historical named-module surface additive while exposing the callable
// facade methods that root consumers expect (`beginCycle`, `trackError`, ...).
const metrics = { ...metricsModule, ...metricsFacade };
export { metrics };
export default {
    v2,
    v3,
    prebid,
    metrics,
};
